import { ReactNode } from 'react'

import './DropDownButton.scss'

import styled from 'styled-components'

import { useDropDownButton } from './DropDownButton'

type DropDownItemProps = {
  children: ReactNode
  as?: string
  className?: string
  value: string | number
}

const Item: any = styled.button`
  border: 0;
  background: var(--wg-background);
`

const DropDownItem = ({ children, value, className }: DropDownItemProps) => {
  const { onSelectItem } = useDropDownButton()

  const onSelected = (event: Event) => {
    event.stopPropagation()
    event.preventDefault()
    onSelectItem(value)
  }

  return (
    <Item type={'button'} onClick={onSelected} className={'floating-menu-item dropdown-item ' + className}>
      {children}
    </Item>
  )
}

DropDownItem.displayName = 'DropDownItem'

export default DropDownItem
